import { useAtomValue } from 'jotai'
import {
  enabledFrameworksAtom,
  hipaaEnabledAtom,
} from '@/stores/workspaceStore'

export { getFrameworkDisplayName } from '@/lib/compliance-framework'

// NOTE: there is intentionally no "active framework" concept. Workspaces are
// multi-framework (frameworks are citation spaces; the framework set is chosen
// per audit cycle). Read the full enrolled set via useEnabledFrameworks() and
// union/loop over it — never pick a single "current" framework.

/** Full list of frameworks the workspace is enrolled in. */
export function useEnabledFrameworks(): string[] {
  return useAtomValue(enabledFrameworksAtom)
}

/** True when HIPAA is in the workspace's enabledFrameworks. */
export function useHipaaEnabled(): boolean {
  return useAtomValue(hipaaEnabledAtom)
}
